const floatMenuPlacerParent = $('.product-float-menu-parent');
const pageSections = $('.shopify-section').slice(4);
const menuPlacer = $('.product-float-menu-parent');
const floatMenuParent = floatMenuPlacerParent.find('.float-menu-parent');
const floatMenuParentHeight = pxToVw(floatMenuParent.outerHeight());
let floatMenuTL; // = gsap.timeline({ paused: true });
/*
function resizePlacer() {
  let height = 0;
  pageSections.slice(0, -2).each(function () {
    height += $(this).outerHeight();
  });
  menuPlacer.height(`${pxToVw(height) + 1.875 - floatMenuParentHeight}vw`);
}

resizePlacer();


$(window).on('resize', function () {
  resizePlacer();
});
*/

let menuInST, menuOutST;

const addFloatMenuAnimation = () => {
  if (menuInST) menuInST.kill();
  if (menuOutST) menuOutST.kill();
  floatMenuTL = gsap.timeline({ paused: true });
    const floatMenuInner = floatMenuParent.find('.float-menu-inner-container');
    const floatMenuOpacityItems = floatMenuInner.find('.float-menu-opacity-item');
    const floatMenuBtnParent = floatMenuParent.find('.button-parent');
    const btnTextOverflow = floatMenuBtnParent.find('.button-text-overflow');
    const btnText = floatMenuBtnParent.find('.button-text');

    gsap.set([floatMenuInner, btnTextOverflow], {
      clearProps: 'width,height,transform',
      visibility: 'hidden',
      display: 'block',
    });

    const floatMenuInnerWidth = pxToVw(floatMenuInner.width());
    const floatMenuInnerHeight = pxToVw(floatMenuInner.height());
    const textWidth = pxToVw(btnText.outerWidth());

    gsap.set([floatMenuInner, btnTextOverflow], {
      clearProps: 'all',
      visibility: 'visible',
    });

    addBtnHover(floatMenuBtnParent);
    floatMenuTL.addLabel('step1');
    floatMenuTL.add(
      gsap.fromTo(
        floatMenuParent,
        {
          opacity: 0,
          y: `${0.938 * 1.5 + floatMenuParentHeight}vw`,
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.63,
          ease: 'pageInEasing',
        }
      ),
      'step1'
    );
    floatMenuTL.add(
      gsap.fromTo(
        btnTextOverflow,
        {
          width: 0,
        },
        {
          width: `${textWidth}vw`,
          duration: 0.83,
          ease: 'pageInEasing',
        }
      ),
      'step1+=0.48'
    );
    floatMenuTL.add(
      gsap.fromTo(
        floatMenuInner,
        {
          width: `${floatMenuInnerHeight}vw`,
          height: `${floatMenuInnerHeight}vw`,
        },
        {
          width: `${floatMenuInnerWidth}vw`,
          height: `${floatMenuInnerHeight}vw`,
          duration: 0.83,
          ease: 'pageInEasing',
        }
      ),
      'step1+=0.48'
    );
    floatMenuTL.add(
      gsap.fromTo(
        floatMenuOpacityItems,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.63,
          ease: 'pageInEasing',
        }
      ),
      'step1+=0.68'
    );


    menuInST = ScrollTrigger.create({
      trigger: $('#attachments-section'),
      start: 'top top',
      onEnter: () => {
        floatMenuTL.play();
      },
      onLeaveBack: () => {
        floatMenuTL.progress(1);
        floatMenuTL.reverse();
      },
    });

    menuOutST = ScrollTrigger.create({
      trigger: $('#app-section'),
      start: 'top top',
      end: 'bottom bottom',
      onEnterBack: () => {
        floatMenuTL.play();
      },
      onLeave: () => {
        floatMenuTL.progress(1);
        floatMenuTL.reverse();
      },
    });
    /*
    const triggerStart = `top bottom`;
    ScrollTrigger.create({
      trigger: floatMenuPlacerParent,
      start: triggerStart,
      end: 'bottom top+=50%',
      onEnter: () => {
        floatMenuTL.play();
      },
      onLeaveBack: () => {
        floatMenuTL.progress(1);
        floatMenuTL.reverse();
      },
      onEnterBack: () => {
        if (!isDesktop()) {
          floatMenuTL.play();
        }
      },
      onLeave: () => {
        if (!isDesktop()) {
          floatMenuTL.progress(1);
          floatMenuTL.reverse();
        }
      },
    });
    */
};

$(window).on('deviceChange', function () {
  if (floatMenuTL) floatMenuTL.kill();
  addFloatMenuAnimation();
});

$(window).on('load', () => {
  addFloatMenuAnimation();
});

//addSectionObserver(floatMenuPlacerParent, addFloatMenuAnimation)